var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibraryMaxillary2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 153,
    viewBox: "0 0 600 153",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1022_124504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.616 54.7865C513.616 54.7865 531.024 18.1783 547.474 13.4674C563.924 8.75637 563.364 1.40515 584.508 5.0068C605.653 8.60846 599.02 42.4433 599.02 57.7004C599.02 72.9575 592.94 111.089 561.713 115.105C530.486 119.121 515.142 100.684 515.142 100.684L513.624 54.7865H513.616Z",
    fill: "url(#paint0_linear_1022_124504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9933 62.2045C85.9933 62.2045 81.2249 48.2712 72.9336 46.6072C64.6423 44.9432 46.8217 3.55003 5.5717 18.7332C5.5717 18.7332 -3.13228 22.2683 1.21603 52.0133C5.56433 81.7584 6.19079 110.875 41.2205 115.453C76.2501 120.031 84.6814 97.2448 84.6814 97.2448L85.9933 62.2045Z",
    fill: "url(#paint1_linear_1022_124504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.518 53.8178C423.518 53.8178 428.905 32.7404 441.066 23.7252C453.226 14.7099 461.377 4.86641 470.634 5.83524C479.891 6.80406 485.971 6.66354 494.955 16.5145C503.939 26.3654 512.643 35.6469 514.854 51.4586C517.065 67.2704 517.618 106.785 512.371 120.378C507.123 133.971 491.779 141.315 472.713 141.87C453.646 142.424 435.406 145.96 426.768 135.251C418.13 124.542 423.518 53.8178 423.518 53.8178Z",
    fill: "url(#paint2_linear_1022_124504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.895 65.3254C179.895 65.3254 151.911 -1.64911 109.423 19.3544C66.9345 40.3579 81.8514 126.265 105.693 132.921C129.535 139.577 169.746 143.948 174.927 128.136C180.108 112.324 179.902 65.318 179.902 65.318L179.895 65.3254Z",
    fill: "url(#paint3_linear_1022_124504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.055 117.324C173.055 117.324 173.881 50.7639 188.392 27.2607C202.904 3.75755 224.255 -5.60527 247.883 3.34339C271.511 12.2921 292.862 36.0023 298.876 63.4548C298.876 63.4548 301.36 81.5518 301.36 93.8211V137.499C301.36 137.499 300.534 143.32 295.56 145.819C290.585 148.319 253.182 158.555 187.604 147.676C181.722 146.7 176.799 142.447 175.318 136.656C175.251 136.39 175.185 136.116 175.126 135.835C173.262 126.894 173.055 117.324 173.055 117.324Z",
    fill: "url(#paint4_linear_1022_124504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.736 97.2151C298.736 97.2151 308.516 51.6953 318.149 40.9865C327.781 30.2776 340.531 12.0771 358.772 6.45644C377.013 0.835786 391.628 3.12842 396.809 5.93874C401.99 8.74907 413.804 16.4405 420.334 32.3558C426.864 48.2711 429.038 66.3607 429.038 71.9814C429.038 77.602 430.799 123.151 426.34 135.938C421.882 148.725 418.049 148.311 408.933 151.122C399.816 153.932 323.536 153.725 313.793 149.561C304.05 145.397 303.74 148.733 300.733 137.81C297.726 126.886 298.729 97.2151 298.729 97.2151H298.736Z",
    fill: "url(#paint5_linear_1022_124504)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.694 132.181C128.565 138.566 166.498 142.848 174.124 129.229C174.389 131.143 174.718 133.134 175.127 135.096C175.186 135.377 175.252 135.65 175.319 135.917C176.8 141.707 181.723 145.96 187.604 146.936C253.183 157.815 290.586 147.579 295.56 145.08C299.01 143.346 300.465 140.015 301.032 138.137C303.048 145.226 303.911 145.491 307.973 146.736C309.432 147.184 311.305 147.758 313.794 148.821C323.537 152.985 399.816 153.192 408.933 150.382C409.992 150.055 410.979 149.773 411.904 149.507C418.948 147.49 422.4 146.501 426.341 135.199C426.438 134.921 426.531 134.629 426.622 134.322C426.671 134.387 426.719 134.45 426.769 134.511C433.842 143.28 447.354 142.498 462.485 141.622L462.486 141.622C465.833 141.429 469.26 141.23 472.713 141.13C491.779 140.575 507.124 133.231 512.371 119.638C514.026 115.351 515.105 108.484 515.736 100.596C518.828 103.838 534.029 117.925 561.714 114.365C592.94 110.349 599.021 72.2177 599.021 56.9606C599.021 54.2987 599.222 51.0714 599.444 47.5377C600.49 30.8176 601.965 7.24028 584.509 4.267C570.583 1.89491 566.072 4.27383 559.915 7.52042C556.724 9.20328 553.09 11.1193 547.475 12.7276C533.728 16.6645 519.312 42.8773 514.945 51.3854L514.921 51.1991C514.913 51.1434 514.906 51.088 514.898 51.0329C514.884 50.9272 514.87 50.8224 514.855 50.7187C512.686 35.2054 504.266 25.9782 495.464 16.3319L494.956 15.7745C486.654 6.67167 480.832 6.1004 472.691 5.30169C472.022 5.23605 471.338 5.16887 470.635 5.0953C463.801 4.38009 457.57 9.55749 449.884 15.9441C447.158 18.2087 444.25 20.6254 441.066 22.9852C432.972 28.9858 427.879 40.3302 425.378 47.2463C424.103 42.139 422.447 36.7637 420.335 31.6159C413.805 15.7006 401.991 8.00917 396.809 5.19884C391.628 2.38852 377.014 0.0958833 358.773 5.71653C343.579 10.3984 332.194 23.8087 323.248 34.3471C321.454 36.4602 319.758 38.4579 318.149 40.2465C311.436 47.7097 304.651 72.0806 301.155 86.1677C300.561 74.9846 298.877 62.7149 298.877 62.7149C292.863 35.2625 271.512 11.5522 247.884 2.60358C224.255 -6.34509 202.904 3.01773 188.393 26.5209C183.547 34.3695 180.227 47.0194 177.955 60.3888C170.935 46.0492 145.37 0.844442 109.423 18.6144C94.9417 25.7732 87.1289 40.4719 84.0653 57.0026C81.943 52.7716 78.1305 46.91 72.9343 45.8672C70.7757 45.434 67.9711 42.3078 64.2753 38.1882C53.7757 26.4846 36.0829 6.76301 5.57242 17.9932C5.57242 17.9932 -3.13156 21.5283 1.21675 51.2734C1.59905 53.8885 1.95258 56.4989 2.30325 59.088L2.30326 59.0882L2.30327 59.0882C5.94115 85.9487 9.27136 110.537 41.2212 114.713C76.2508 119.291 84.6821 96.5048 84.6821 96.5048L84.6835 96.4681C88.3633 114.766 96.342 129.57 105.694 132.181Z",
    fill: "#DBDAD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1022_124504",
    x1: 583.307,
    y1: -159.745,
    x2: 583.307,
    y2: 129.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DCD2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E8E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F0EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAB9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1022_124504",
    x1: 67.1628,
    y1: -141.256,
    x2: 67.1628,
    y2: 133.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DCD2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E8E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F0EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAB9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1022_124504",
    x1: 516.461,
    y1: 5.91674,
    x2: 516.461,
    y2: 147.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DCD2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E8E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAB9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1022_124504",
    x1: 179.895,
    y1: 15.5307,
    x2: 179.895,
    y2: 153.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DCD2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E8E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F0EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922901,
    stopColor: "#CAB9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1022_124504",
    x1: 284.482,
    y1: 7.02581,
    x2: 284.482,
    y2: 167.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DCD2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E8E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F0EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAB9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1022_124504",
    x1: 375.871,
    y1: 9.24451,
    x2: 375.871,
    y2: 155.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DCD2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E8E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F0EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAB9B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1022_124504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 153,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryMaxillary2);
export default __webpack_public_path__ + "static/media/library_maxillary2.522cd9aebb253651c1ed3b55bf542c68.svg";
export { ForwardRef as ReactComponent };